export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden h-[600px]">
            <img
              src="https://readdy.ai/api/search-image?query=happy%20diverse%20family%20at%20home%20with%20medicine%20cabinet%20in%20background%20warm%20natural%20lighting%20showing%20trust%20and%20care%20modern%20healthcare%20lifestyle%20professional%20photography%20with%20soft%20focus%20creating%20welcoming%20atmosphere%20people%20smiling%20confidently&width=800&height=1000&seq=about-img-001&orientation=portrait"
              alt="Healthcare Mission"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-8 left-8">
              <span className="block text-white text-sm font-medium mb-2 whitespace-nowrap">
                Our Mission
              </span>
              <h3 className="text-5xl font-bold text-white">Healthcare</h3>
            </div>
          </div>

          <div className="lg:pl-12">
            <h2 className="text-6xl font-bold text-[#144E5D] mb-8 leading-tight">
              About Curewell
            </h2>

            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                Curewell is built on a simple principle: essential medicine
                should be reliable, accessible, and reasonably priced. We focus
                on everyday over-the-counter care that people depend on
                regularly not specialty hype, not inflated formulations. Just
                medicine that works.
              </p>

              <p>
                Our portfolio addresses common health needs including pain
                management, digestive support, cold, flu, and allergy relief.
                Every Curewell product is developed with clear dosing, proven
                ingredients, and practical affordability, so effective care
                stays within reach for daily life.
              </p>

              <p>
                From acid reducers and cough relief to digestive aids and
                urinary health supplements, Curewell delivers trusted solutions
                without unnecessary complexity. We prioritize consistency,
                transparency, and sensible pricing because healthcare should
                support everyday living, not complicate it.
              </p>
            </div>

            {/* <button className="mt-8 px-8 py-3 bg-[#144E5D] hover:bg-[#B8D8DE] text-white hover:text-[#144E5D] font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2">
              Learn Our Story
              <i className="ri-arrow-right-line"></i>
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
}
